import { Col, Row, Button, Picture, Quote } from 'darrius';

import styles from './Testimonial.module.scss';

interface ITestimonialProps {
  testimonialContent?: {
    image?: {
      sm: string;
      md: string;
      lg: string;
      alt: string;
    };
    title: string;
    subTitle: string;
    text: string;
    watchLink: {
      text: string;
      url: string;
    };
  };
}

export const Testimonial = (props: ITestimonialProps) => {
  const { testimonialContent } = props;

  if (!testimonialContent) {
    return null;
  }

  const { image, title, subTitle, text, watchLink } = testimonialContent;

  const clickButton = () => {
    window.tagManager.custom({
      event: 'selfDescribingEvent',
      schema: 'iglu:br.com.getninjas/web_pro_sign_up/jsonschema/1-0-1',
      data: {
        step: 'success_storie_video',
        action: 'click',
        state: watchLink.url,
        label: `${title} - ${subTitle}`,
      },
    });
  };

  const defaultImageSize = {
    lg: {
      width: 160,
      height: 377,
    },
    md: {
      width: 124,
      height: 292,
    },
    sm: {
      width: 328,
      height: 200,
    },
  };

  return (
    <Col className={`col-sm-12 col-md-6  testimonial ${styles.testimonial} `}>
      <Row>
        <Col className="col-sm-12 center-sm col-md-4">
          <Picture
            className="picture"
            src={{
              sm: image.sm,
              md: image.md,
              lg: image.lg,
            }}
            size={defaultImageSize}
            alt={image.alt}
          />
        </Col>

        <Col className="col-sm-12 col-md-7">
          <Quote title={title} subTitle={` - ${subTitle}`} text={text} />

          <Button.Link
            className="button clear"
            href={watchLink.url}
            onClick={clickButton}
            fullWidth
          >
            {watchLink.text}
          </Button.Link>
        </Col>
      </Row>
    </Col>
  );
};

export default Testimonial;
